import { i18n } from '@lingui/core';
import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconArrowDownCircle, IconArrowUpCircle, IconCopy, IconTrashX } from '@tabler/icons';
import { FC } from 'react';
import { QuestionHandlers } from '../../../Types/QuestionnaireT';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';

interface Props {
  questionsLength: number;
  isFirst: boolean;
  isLast: boolean;
  bundleId: string;
  questionId: string;
  questionHandlers: QuestionHandlers;
}

const QuestionActions: FC<Props> = ({ questionsLength, isFirst, isLast, bundleId, questionId, questionHandlers }) => {
  const { shiftQuestion, duplicateQuestion, deleteQuestion } = questionHandlers;

  const deleteHandler = () =>
    openDeleteConfirmModal({
      title: i18n._('questionnaire.question.delete.confirm.head'),
      description: i18n._('questionnaire.question.delete.confirm'),
      onConfirm: () => deleteQuestion(bundleId, questionId),
    });

  return (
    <Menu radius="md" shadow="md" width={180} transition="slide-down" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots color="black" />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {questionsLength > 0 && (
          <>
            {!isFirst && (
              <Menu.Item icon={<IconArrowUpCircle size={16} />} onClick={() => shiftQuestion(bundleId, questionId, -1)}>
                {i18n._('actions.up')}
              </Menu.Item>
            )}
            {!isLast && (
              <Menu.Item
                icon={<IconArrowDownCircle size={16} />}
                onClick={() => shiftQuestion(bundleId, questionId, 1)}
              >
                {i18n._('actions.down')}
              </Menu.Item>
            )}
          </>
        )}
        <Menu.Item icon={<IconCopy size={16} />} onClick={() => duplicateQuestion(bundleId, questionId)}>
          {i18n._('actions.duplicate')}
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={deleteHandler}>
          {i18n._('actions.delete')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default QuestionActions;
